import { Component, Input, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { OcrFieldStyleService } from '../ocr-field-style.service';

/**
 * Ícone ao lado da label que exibe a origem do valor (documento OCR) em um popover.
 * Usa mousedown preventDefault/stopPropagation para não acionar o foco no input quando
 * o ícone está dentro de um <label>. Ao abrir, fecha os demais popovers (um por vez).
 */
@Component({
  selector: 'app-admission-form-ocr-source-icon',
  templateUrl: './ocr-source-icon.component.html',
  styleUrls: ['./ocr-source-icon.component.scss'],
})
export class OcrSourceIconComponent {
  @Input() visible = false;
  @Input() sourceText = '';

  @ViewChild(NgbPopover) popover: NgbPopover;

  private registeredCloseFn: (() => void) | null = null;

  constructor(private ocrFieldStyleService: OcrFieldStyleService) {}

  onIconMouseDown(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onPopoverShown(): void {
    this.registeredCloseFn = () => this.popover?.close();
    this.ocrFieldStyleService.registerPopoverOpen(this.registeredCloseFn);
  }

  onPopoverHidden(): void {
    if (this.registeredCloseFn) {
      this.ocrFieldStyleService.unregisterPopover(this.registeredCloseFn);
      this.registeredCloseFn = null;
    }
  }
}
